import { Grid, useMediaQuery } from "@mui/material";
import { DateField, Labeled, SelectField, TextField, useRecordContext } from "react-admin";
import { AcademicRequestStatus } from "utils/choices";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { settings } from "app";
import ChangeStatusDialog from "../../components/ChangeStatusDialog";
import { SectionTitle } from "features/SectionTitle";

const RequestInfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  return (
    <>
      <SectionTitle
        title="Информация за заявката"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Тема">
            <TextField source="topicNameBg" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Статус">
            <SelectField
              source="status"
              choices={AcademicRequestStatus}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Създаден">
            <DateField
              source="createdOn"
              locales="bg-BG"
              showTime
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Labeled label="Забележка">
            <TextField
              source="note"
              emptyText="-"
              sx={{ whiteSpace: "pre-wrap" }}
            />
          </Labeled>
        </Grid>
        <SecuredComponent permission={permissions.canChangeAcademicRequestStatus}>
          <Grid
            item
            xs={12}
          >
            <ChangeStatusDialog record={record} />
          </Grid>
        </SecuredComponent>
      </Grid>
    </>
  );
};

export default RequestInfoSection;
